import { z } from 'zod'
import { POSITION_TYPES, ALLOCATION_STATUSES } from '@/types/allocations'

export const allocationFormSchema = z.object({
  // Required fields
  aircraft_id: z.string().min(1, 'Aircraft is required'),
  location_id: z.string().min(1, 'Location is required'),
  position_type: z.enum(POSITION_TYPES, {
    errorMap: () => ({ message: 'Position type is required' }),
  }),

  // Position (numbers with defaults)
  position_x: z.number().default(0),
  position_y: z.number().default(0),
  position_z: z.number().default(0),
  rotation: z.number().default(0),

  // Optional space allocation
  area_id: z.string().optional().nullable(),
  unit_id: z.string().optional().nullable(),
  zone_id: z.string().optional().nullable(),

  // Display customization
  custom_label: z.string().optional().nullable(),
  show_label: z.boolean().default(false),
  color_override: z.string().optional().nullable(),

  // Status
  status: z.enum(ALLOCATION_STATUSES).default('active'),

  // Links
  lease_contract_id: z.string().optional().nullable(),
  transient_stay_id: z.string().optional().nullable(),
})

export type AllocationFormSchema = z.infer<typeof allocationFormSchema>
